import { Button, Tab, styled } from "@mui/material";

export const PrimaryButton = styled(Button)(() => ({
  backgroundColor: "#4D6BF6",
  color: "#fff",
  textTransform: "none",
  fontWeight: 500,
  borderRadius: "10px",
  boxShadow: "none",
  padding: "8px 18px",
  fontFamily: "Inter Tight",
  "&:hover": { backgroundColor: "#3B5BDB", boxShadow: "none" },
  "&.Mui-disabled": { backgroundColor: "#A8B5F8", color: "#fff" },
}));

export const SecondaryButton = styled(Button)(() => ({
  backgroundColor: "#fff",
  color: "#0D0D0E",
  textTransform: "none",
  fontWeight: 500,
  borderRadius: "10px",
  border: "1px solid #D7D8D9",
  boxShadow: "none",
  padding: "8px 18px",
  fontFamily: "Inter Tight",
  "&:hover": { backgroundColor: "#F9FAFB", boxShadow: "none" },
}));

export const StyledTab = styled(Tab)(({ selected }) => ({
  color: selected ? "#fff !important" : "#949DAA",
  backgroundColor: selected ? "#0d0d0d !important" : "#fff !important",
  border: "1px solid #d7d8d9",
  borderRadius: "10px",
  minHeight: "36px !important",
  fontWeight: 500,
  textTransform: "none",
  marginRight: "10px",
  padding: "4px 16px !important",
  fontFamily: "Inter Tight",
  fontSize: "13px",
  "&:hover": {
    backgroundColor: selected ? "#0d0d0d" : "",
    color: !selected && "#000",
  },
}));
